<template>
  <router-link :to="{ name: 'course.show', params: {id: course.id, slug: course.slug} }" class="course">
    <div class="course__thumb">
      <CourseThumb :course="course"/>

      <RoundIcon class="pos-bottom-center">
        <BadgeSVG/>
      </RoundIcon>
    </div>

    <div>
      <slot name="name">
        <h6 class="course__name">{{ course.name }}</h6>
      </slot>
    </div>
  </router-link>
</template>

<script>
import CourseThumb from '@/components/course/CourseThumb'
import RoundIcon from '@/components/icon/RoundIcon'
import BadgeSVG from '@/components/svg/BadgeSVG'

export default {
  components: {
    CourseThumb,
    RoundIcon,
    BadgeSVG,
  },

  props: {
    course: { type: Object, required: true }
  }
}
</script>

<style scoped lang="scss">
  .course {
    display: flex;
    align-items: center;
    gap: 10px;

    &__thumb {
      position: relative;
      width: 110px;
      flex: 0 0 auto;
    }

    &__name {

    }
  }
</style>